import React, { useState, useEffect } from 'react';
import { toast } from "react-toastify";
import service from '../services/service';
import DashboardLayout from './layout/dashboardLayout';
import LoadingOverlay from '../components/loading/loading';

const HomePage = () => {
    const [metrics, setMetrics] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getDashboardMetrics();
    }, []);

    const getDashboardMetrics = async () => {
        setLoading(true);
        try {
            const response = await service.view('admin/metrics', { method: 'GET' });
            if (!response.success) {
                toast.error(response.message);
                return;
            }
            setMetrics(response.metrics);
        } catch (error) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };

    const colors = {
        primary: '#2563eb',
        text: '#475569',
        white: '#ffffff'
    };

    const StatsCard = ({ title, value, icon }) => (
        <div style={{
            backgroundColor: colors.white,
            borderRadius: '12px',
            padding: '24px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                <span style={{ fontSize: '24px' }}>{icon}</span>
                <h3 style={{ fontSize: '16px', color: colors.text }}>{title}</h3>
            </div>
            <p style={{ fontSize: '24px', fontWeight: '600', color: colors.primary }}>
                {value}
            </p>
        </div>
    );

    return (
        <DashboardLayout>
            {loading && <LoadingOverlay />}
            <h2 style={{ fontSize: '28px', fontWeight: '600', marginBottom: '24px', color: '#1e293b' }}>
                Welcome back
            </h2>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px', marginBottom: '32px' }}>
                <StatsCard title="Total Users" value={metrics?.totalUsers ?? 0} icon="👥" />
                <StatsCard title="Hotels" value={metrics?.totalHotels ?? 0} icon="🏨" />
                <StatsCard title="Bookings" value={metrics?.totalBookings ?? 0} icon="📖" />
                <StatsCard title="Active Users" value={metrics?.activeUsers ?? 0} icon="🔥" />
                <StatsCard title="Blocked Users" value={metrics?.blockedUsers ?? 0} icon="🚫" />
            </div>
        </DashboardLayout>
    );
};

export default HomePage;